import React from "react";

import { FormControlBasisPointBox } from "../..";
import FormControlPercentageBox from "../../FormControlPercentageBox";

const FieldInputBasisPoint = ({ field, form, onChange, ...rest }) => {
  let prevValue;
  const { max } = rest;
  const countDecimals = function (value) {
    if (Math.floor(value) === value) return 0;
    return value?.toString()?.split(".")[1]?.length || 0;
  };

  return (
    <FormControlBasisPointBox
      {...field}
      {...form}
      {...rest}
      autoComplete="off"
      type="number"
      step="1"
      onKeyDown={(evt) => {
        if (evt.key === "e" || evt.key === "E" || evt.key === "-")
          evt.preventDefault();
        prevValue = evt.target.value;
      }}
      onChange={(evt) => {
        if (countDecimals(evt.target.value) > 2 || evt.target.value > max) {
          evt.target.value = prevValue;
        }
        onChange(evt);
      }}
    />
  );
};

export default FieldInputBasisPoint;
